<template>
  <div>
    <div class="wrap message-wrap">
      <div class="header-wrap">
        <div class="top-header">
          <!-- <button><img src="@/assets/img/back-icon.svg" alt="preview"></button> -->
          <incBack></incBack>
          <h3 v-if="coarchIdx == -1">1:1문의</h3>
          <h3 v-else>{{ coachInfo.userName }} 코치님</h3>
        </div>
      </div>

      <div class="body-wrap">
        <div class="chat" v-if="coarchIdx == -1">
          <div class="messages" v-for="(item, index) in chat" :key="index">
            <div class="time">
              {{ item[0].chatGroup }}
            </div>

            <div
              :class="{
                'message-coach-wrap': subItem.qna_parent_qna_idx > 0,
                'message-me-wrap': subItem.qna_parent_qna_idx == null,
              }"
              v-for="(subItem, subIndex) in item"
              :key="subIndex"
            >
              <div class="message" :class="{ coach: subItem.qna_parent_qna_idx > 0, me: subItem.qna_parent_qna_idx == null }">
                <div v-html="subItem.qna_content"></div>
              </div>
              <span>{{ subItem.sendTime }}</span>
            </div>
          </div>
          <div class="input">
            <textarea v-model="input.chatContent"></textarea>
            <img src="@/assets/img/message_send.svg" alt="메시지 보내기 아이콘" @click="chatSend()" />
          </div>
        </div>
        <div class="chat" v-else>
          <div class="messages" v-for="(item, index) in chat" :key="index">
            <div class="time">
              {{ item[0].chatGroup }}
            </div>

            <div
              :class="{ 'message-coach-wrap': subItem.sender == 'COACH', 'message-me-wrap': subItem.sender == 'USER' }"
              v-for="(subItem, subIndex) in item"
              :key="subIndex"
            >
              <div class="message" :class="{ coach: subItem.sender == 'COACH', me: subItem.sender == 'USER' }">
                <div v-html="subItem.chatContent"></div>
              </div>
              <span>{{ subItem.sendTime }}</span>
            </div>
          </div>
          <div class="input">
            <textarea v-model="input.chatContent" placeholder="메세지를 입력해주세요."></textarea>
            <img src="@/assets/img/message_send.svg" alt="메시지 보내기 아이콘" @click="chatSend()" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import incBack from "@/components/inc/inc_back.vue";
import dayjs from "dayjs";
import { groupBy } from "@/utils/common";
export default {
  name: "message",
  props: {
    coarchIdx: {
      type: [Number, String],
      default: 0,
    },
  },
  data: () => ({
    chat: [],
    input: {
      userIdx: 0,
      coachIdx: 0,
      origin: "USER",
      chatContent: "",
    },
    coachInfo: {},
    detailList: "",
    loading: false,
  }),
  components: { incBack },
  created() {
    this.loading = true;
  },
  async mounted() {
    console.log(this.coarchIdx, "-1 이면, HQ 채팅, 아니면 채팅방으로 구현");
    if (this.coarchIdx == -1) {
      this.getQnaDetail();
      this.detailList = setInterval(() => {
        this.getQnaDetail();
      }, 2000);
    } else {
      let returnTemp = await this.getChatDetail();
      this.groupByChatList(returnTemp);

      this.detailList = setInterval(() => {
        this.getChatDetail();
      }, 2000);
    }
    // nextTick 으로 처리하고 싶었지만, data 반응 속도와 시간이 맞지 않아 timeout 처리
    setTimeout(() => {
      window.scrollTo(0, document.body.scrollHeight);
    }, 100);
  },
  methods: {
    getQnaDetail() {
      this.axios
        .get(`/qna/user/${this.$store.state.userInfo.userIdx}`)
        .then((res) => {
          if (res.data.success) {
            let temp = res.data.data;
            this.groupByChatList(temp);
            const isAtBottom = document.body.scrollHeight - window.innerHeight <= window.scrollY + 1;
            if (isAtBottom) {
              this.$nextTick(() => {
                window.scrollTo(0, document.body.scrollHeight);
              });
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    chatSend() {
      if (this.input.chatContent == "") {
        alert("내용을 입력해주세요.");
        return false;
      }
      if (this.coarchIdx == -1) {
        let params = {
          qnaContent: this.input.chatContent,
        };
        this.axios
          .post("/qna/user", params)
          .then((res) => {
            if (res.data.success) {
              // data 가 보내졌는데, redirect 를 하는 이유를 알 수 없음.
              // this.$router.go(0);
              this.getQnaDetail();
              this.input.chatContent = "";

              this.$nextTick(() => {
                window.scrollTo(0, document.body.scrollHeight);
              });
            }
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        this.input.userIdx = this.$store.state.userInfo.userIdx;
        this.input.coachIdx = this.coarchIdx;
        let params = this.input;
        this.axios
          .post("/chat/send", params)
          .then((res) => {
            if (res.data.success) {
              this.input.chatContent = "";
              let temp = res.data.contentinfo.chatList;
              this.groupByChatList(temp);
              this.$nextTick(() => {
                window.scrollTo(0, document.body.scrollHeight);
              });
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    getChatDetail() {
      let params = {
        userIdx: this.$store.state.userInfo.userIdx,
        coachIdx: this.coarchIdx,
        origin: "USER",
      };

      return this.axios
        .get("/chat/detail", { params })
        .then((res) => {
          let tempReturn = [];
          if (res.data.success) {
            let temp = res.data.contentinfo.chatList;
            this.coachInfo = res.data.contentinfo.coachInfo;
            this.groupByChatList(temp);
            tempReturn = temp;
            // 스크롤이 맨 아래 인지 확인하는 code
            // 맨 아래 일때만 Data 가져오면 그 이후 아래로 이동
            const isAtBottom = document.body.scrollHeight - window.innerHeight <= window.scrollY + 1;
            if (isAtBottom) {
              this.$nextTick(() => {
                window.scrollTo(0, document.body.scrollHeight);
              });
            }
          }
          return tempReturn;
        })
        .catch((err) => {
          console.log(err);
          return [];
        });
    },
    groupByChatList(temp) {
      // 해당 temp 조회 결과 object array 인 상태
      // 해당 부분을 동기화 시키고 싶다면, for 문 사용이, for of 보다 빠름
      // for of 문은 iterable 객체 사용 시 사용하는게 좋음

      for (let i = 0; i < temp.length; i++) {
        let groupDate = dayjs(temp[i].chatRegistDatetime).format("YYYY년 MM월 DD일");
        this.$store.commit("setCoachingDays", dayjs(temp[i].chatRegistDatetime).day());
        let days = this.$store.state.coachingDays;
        temp[i].chatGroup = groupDate + " " + days + "요일";
        temp[i].sendTime = dayjs(temp[i].chatRegistDatetime).format("HH:mm");
      }

      this.chat = groupBy(temp, "chatGroup");
    },
  },
  destroyed() {
    clearInterval(this.detailList);
  },
};
</script>
<style lang="scss" scoped>
.header-wrap {
  width: 100%;
  position: fixed;
  background: #fff;
  z-index: 1;
  .top-header {
    width: 90%;
    margin: 0 auto;
  }
}
</style>
